import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { GatewayDetails } from "@src/types/gateway-onboarding";

export const getGatewayById = async (
  namespace: string,
  gatewayId: string,
  signal?: AbortSignal,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GatewayDetails>(
      `${url}/api/v3/ns/${namespace}/gateways/${gatewayId}`,
      { headers, signal },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch gateway information. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while fetching gateway information.",
    );
  }
};
